<div class="form-group" ngModelGroup="formField{{ formField.id }}">
    <sb-form-field-label [formField]="formField"></sb-form-field-label>
    <div class="form-control-container">
        <label
            class="checkbox__label"
            [ngClass]="{
                'ng-invalid':
                    (formService.isSubmitted && formField.isRequired && !isChecked) ||
                    (formService.isSubmitted && formField.options?.isConfirmation === 'true' && !isChecked),
            }">
            <input
                id="form-element-{{ formField.id }}"
                type="checkbox"
                name="formField{{ formField.id }}"
                [(ngModel)]="isChecked"
                (change)="onChange()"
                [required]="formField.isRequired" />
            <span class="checkbox__checkmark"></span>
            {{ formField.options?.checkboxSideLabel }}
        </label>
    </div>
    @if (formService.isSubmitted && formField.isRequired && !isChecked) {
        <div class="text-danger" translate>Please fill this field</div>
    }
</div>
